export const LINK_STORE_REGISTRY_ERRORS = {
  SYNC_PRODUCT_ERROR: 'syncProductError',
  REGISTRY_ALREADY_CLAIMED: 'registryAlreadyClaimed',
  REGISTRY_URL_NOT_MATCH_DOMAIN: 'registryUrlNotMatchDomain',
  REGISTRY_URL_NOT_CODE: 'registryUrlNotCode',
  REGISTRY_RETAILER_ID_NOT_MATCH_DOMAIN: 'registryRetailerIdNotMatchDomain',
  REGISTRY_NOT_FOUND: 'registryNotFound',
  REGISTRY_CODE_EXIST: 'registryCodeExist',
  REGISTRY_ALREADY_LINKED_BY_SELF: 'registryAlreadyLinkedBySelf',
  REGISTRY_PRODUCT_UNREACHABLE: 'registryProductUnreachable',
  SERVER_ERROR: 'serverError',
};
export const RELINK_REGISTRY_STATUS = {
  RELINK_SUCCESS: 'relinkSuccess',
  INCORRECT_EMAIL: 'incorrectEmail',
  MAX_ATTEMPTS: 'maxAttempts',
};
export const LINK_STORE_REGISTRY_ERRORS_LOOKUP = {
  10001: LINK_STORE_REGISTRY_ERRORS.REGISTRY_ALREADY_CLAIMED,
  10002: LINK_STORE_REGISTRY_ERRORS.REGISTRY_URL_NOT_MATCH_DOMAIN,
  10003: LINK_STORE_REGISTRY_ERRORS.REGISTRY_URL_NOT_CODE,
  10004: LINK_STORE_REGISTRY_ERRORS.REGISTRY_RETAILER_ID_NOT_MATCH_DOMAIN,
  10005: LINK_STORE_REGISTRY_ERRORS.REGISTRY_NOT_FOUND,
  10006: LINK_STORE_REGISTRY_ERRORS.REGISTRY_CODE_EXIST,
  10007: LINK_STORE_REGISTRY_ERRORS.REGISTRY_ALREADY_LINKED_BY_SELF,
  10008: LINK_STORE_REGISTRY_ERRORS.REGISTRY_PRODUCT_UNREACHABLE,
};
